import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const CustomButton = styled(ButtonMui)`
    width: 14.5rem;
`

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0.4rem 0.4rem 0.8rem 0.4rem;
`

export const CustomFieldMui = styled(TextFieldMui)`
  width: 90%;
  margin-top: 20px !important;
`

export const CustomButtonAdd = styled(ButtonMui)`
  width: 90%;
  margin-top: 4px !important;
  height: 36px;
`

export const ModalFooter = styled.div`
  background-color: #FFF;
  flex: '1 1 auto';
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  padding: 12px 7px 14px 7px
`

export const CustomButtonApply = styled(ButtonMui)`
  width: 90%;
  height: 36px;
`
